import { Metamodel } from 'app/model/base/model';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { DatabricksDataset } from 'app/model/dataset/databricks.dataset';
import { TabularCopySink } from './tabular.copysink';
import { IAttribute } from 'app/model/base/annotation';

@Metamodel.model({
    name: adfModelTypeMap.databricks.copySinkType,
    display: [],
    tags: { datasetModel: [Metamodel.modelFor(DatabricksDataset)] }
})
export class DatabricksSink extends TabularCopySink {
    public static readonly DATE_FORMAT: IAttribute;
    public static readonly TIMESTAMP_FORMAT: IAttribute;

    @Metamodel.attribute({
        association: 'DATE_FORMAT',
        templatable: true
    })
    public dateFormat?: string;

    @Metamodel.attribute({
        association: 'TIMESTAMP_FORMAT',
        templatable: true
    })
    public timestampFormat?: string;
}
